export default __webpack_public_path__ + "static/media/best_review_bg.5d37a2ab.png";